document.addEventListener('DOMContentLoaded', () => {
  let priceInitTimer = null;

  function getCollectionLayout(trigger) {
    return trigger?.closest('.cb-collection-layout') || document.querySelector('.cb-collection-layout');
  }

  function getSortSheet() {
    return document.querySelector('[data-cb-mobile-sort-sheet]');
  }

  function lockPage() {
    document.documentElement.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden');
  }

  function unlockPageIfSafe() {
    const filterDrawerOpen = document.querySelector('[data-cb-filter-drawer].is-open');
    const sortSheetOpen = document.querySelector('[data-cb-mobile-sort-sheet].is-open');

    if (!filterDrawerOpen && !sortSheetOpen) {
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');
    }
  }

  function openSortSheet() {
    const sortSheet = getSortSheet();
    if (!sortSheet) return;

    sortSheet.classList.add('is-open');
    lockPage();
  }

  function closeSortSheet() {
    const sortSheet = getSortSheet();
    if (!sortSheet) return;

    sortSheet.classList.remove('is-open');
    unlockPageIfSafe();
  }

  function cleanPriceNumber(value, fallback = 0) {
    const number = Number(String(value || '').replace(/,/g, '').replace(/[^\d.]/g, ''));
    return Number.isFinite(number) ? number : fallback;
  }

  function updateDesktopPriceRange(wrap) {
    const min = Number(wrap.dataset.min || 0);
    const max = Number(wrap.dataset.max || 0);

    const minRange = wrap.querySelector('[data-cb-range-min]');
    const maxRange = wrap.querySelector('[data-cb-range-max]');
    const minInput = wrap.querySelector('[data-cb-input-min]');
    const maxInput = wrap.querySelector('[data-cb-input-max]');

    if (!minRange || !maxRange || !minInput || !maxInput || max <= min) return;

    let minVal = cleanPriceNumber(minRange.value, min);
    let maxVal = cleanPriceNumber(maxRange.value, max);

    minVal = Math.max(min, Math.min(minVal, max));
    maxVal = Math.max(min, Math.min(maxVal, max));

    if (minVal > maxVal) minVal = maxVal;
    if (maxVal < minVal) maxVal = minVal;

    minVal = Math.round(minVal);
    maxVal = Math.round(maxVal);

    minRange.value = minVal;
    maxRange.value = maxVal;
    minInput.value = minVal;
    maxInput.value = maxVal;

    const left = ((minVal - min) / (max - min)) * 100;
    const right = ((maxVal - min) / (max - min)) * 100;

    wrap.style.setProperty('--cb-desktop-price-left', `${left}%`);
    wrap.style.setProperty('--cb-desktop-price-right', `${100 - right}%`);
  }

  function submitDesktopPriceToDawn(wrap) {
    const minInput = wrap.querySelector('[data-cb-input-min]');

    if (!minInput) return;

    wrap.dataset.cbAllowSubmit = 'true';

    minInput.dispatchEvent(new Event('input', { bubbles: true }));

    requestAnimationFrame(() => {
      wrap.dataset.cbAllowSubmit = 'false';
    });
  }

  function initDesktopPriceRanges() {
    document.querySelectorAll('[data-cb-desktop-price-range]').forEach((wrap) => {
      if (wrap.dataset.cbDesktopPriceReady === 'true') {
        updateDesktopPriceRange(wrap);
        return;
      }

      wrap.dataset.cbDesktopPriceReady = 'true';
      wrap.dataset.cbAllowSubmit = 'false';

      const minRange = wrap.querySelector('[data-cb-range-min]');
      const maxRange = wrap.querySelector('[data-cb-range-max]');
      const minInput = wrap.querySelector('[data-cb-input-min]');
      const maxInput = wrap.querySelector('[data-cb-input-max]');

      if (!minRange || !maxRange || !minInput || !maxInput) return;

      [minRange, maxRange].forEach((range) => {
        range.addEventListener('input', (event) => {
          event.stopPropagation();

          if (Number(minRange.value) > Number(maxRange.value)) {
            if (range === minRange) minRange.value = maxRange.value;
            if (range === maxRange) maxRange.value = minRange.value;
          }

          updateDesktopPriceRange(wrap);
        });

        range.addEventListener('change', (event) => {
          event.stopPropagation();
          updateDesktopPriceRange(wrap);
          submitDesktopPriceToDawn(wrap);
        });
      });

      [minInput, maxInput].forEach((input) => {
        input.addEventListener('input', (event) => {
          if (wrap.dataset.cbAllowSubmit === 'true') return;

          event.stopPropagation();

          const max = Number(wrap.dataset.max || 0);

          minRange.value = cleanPriceNumber(minInput.value, 0);
          maxRange.value = cleanPriceNumber(maxInput.value, max);

          if (Number(minRange.value) > Number(maxRange.value)) {
            minRange.value = maxRange.value;
          }

          updateDesktopPriceRange(wrap);
        });

        input.addEventListener('change', () => {
          updateDesktopPriceRange(wrap);
          submitDesktopPriceToDawn(wrap);
        });
      });

      updateDesktopPriceRange(wrap);
    });
  }

  function schedulePriceRangeInit() {
    clearTimeout(priceInitTimer);

    priceInitTimer = setTimeout(() => {
      initDesktopPriceRanges();
    }, 120);
  }

  document.addEventListener('click', (event) => {
    const desktopToggle = event.target.closest('[data-cb-desktop-filter-toggle]');

    if (desktopToggle) {
      event.preventDefault();

      const layout = getCollectionLayout(desktopToggle);
      if (!layout) return;

      const isOpen = layout.classList.toggle('is-filters-open');
      desktopToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      setTimeout(initDesktopPriceRanges, 80);
      setTimeout(initDesktopPriceRanges, 250);
      return;
    }

    if (event.target.closest('[data-cb-mobile-sort-open]')) {
      event.preventDefault();
      openSortSheet();
      return;
    }

    if (event.target.closest('[data-cb-mobile-sort-close]')) {
      event.preventDefault();
      closeSortSheet();
      return;
    }

    const sortOption = event.target.closest('[data-cb-mobile-sort-option]');

    if (sortOption) {
      event.preventDefault();

      const value = sortOption.getAttribute('data-sort-value');
      if (!value) return;

      const mobileSelect = document.querySelector('#SortBy-mobile');
      const desktopSelect = document.querySelector('#SortBy');
      const targetSelect = mobileSelect || desktopSelect;

      if (!targetSelect) return;

      targetSelect.value = value;

      targetSelect.dispatchEvent(new Event('input', { bubbles: true }));
      targetSelect.dispatchEvent(new Event('change', { bubbles: true }));

      document.querySelectorAll('[data-cb-mobile-sort-option]').forEach((el) => {
        el.classList.remove('is-active');
      });

      sortOption.classList.add('is-active');
      closeSortSheet();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeSortSheet();
    }
  });

  document.addEventListener('shopify:section:load', () => {
    schedulePriceRangeInit();
  });

  const observer = new MutationObserver(() => {
    schedulePriceRangeInit();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  initDesktopPriceRanges();
});